




















import {
  defineComponent,
  PropType,
  computed
} from '@nuxtjs/composition-api';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { usePriceRequest } from '@wemade-vsf/catalog/lib/runtime/product/composables/usePriceRequest';

export default defineComponent({
  name: 'ProductCardActions',
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true
    },
    link: {
      type: [String, Object],
      default: ''
    },
    actions: {
      type: Array as PropType<string[]>,
      default: () => ['link', 'cart']
    }
  },
  components: {
    AddToCart: () => import('components/catalog/Product/ProductCard/AddToCart.vue'),
    PriceRequestButton: () => import('components/catalog/Product/PriceRequestButton.vue')
  },
  setup (props) {
    const showAddToCart = computed(() => props.actions.includes('cart') && !['ConfigurableProduct', 'BundleProduct', 'GroupedProduct'].includes(props.product.__typename))
    const showLink = computed(() => props.actions.includes('link'));
    const showPriceRequest = computed(() => props.actions.includes('quote'));

    const { openPriceRequestModal } = usePriceRequest();

    return {
      showLink,
      showAddToCart,
      showPriceRequest,
      openPriceRequestModal
    }
  }
})
